const Section_Content = ({children}) => {
  return <div className="leading-relaxed">{children}</div>;
};

export default Section_Content;
